export default "__VITE_ASSET__D7m9Yhcl__"